import {BaseTO, SubProfile} from "./BaseTO";
import {TicketOverviewCL} from "../generated/TicketOverviewCL";
import {MuEvent, MuNamedWidgets, MuUi, MuWidget} from "mu-widget/lib/MuWidget";
import {PqmTicketList} from "../pqm/PqmTicketList";
import { Attaches2 } from "../Attaches2";
import {Pager} from "../components/Pager";
import {TicketsCL} from "../generated/TicketsCL";
import {PqmCL} from "../generated/PqmCL";
import {Arrays, changeClassStartsWith} from "../Utils";
import {CalendarPage} from "../CalendarPage";
import {PqmTicketDetail} from "../pqm/PqmTicketDetail";
import {TodoTicketForm} from "../TodoTicketForm";
import {Ticket} from "../TicketTypes";
import {UiPqmLauncher} from "./pqm/UiPqmLauncher";
import {MuRouterContext} from "mu-widget/lib/MuRouter";
import {BaseRouter} from "../BaseRouter";
import {DelayedSingleLauncher} from "../../DelayedSingleLauncher";
import {UiChboxList} from "../components/UiChboxList";
import {MuBinder} from "mu-widget/lib/MuBinder";
import {UiPqmFilter} from "./pqm/UiPqmFilter";
import {BaseMuWidget} from "../BaseMuWidget";

export class TOPqm extends BaseTO
{
	// public cl: TicketsCL = new TicketsCL();
	public ticketsCL = new TicketsCL();

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		procDataTickets: PqmTicketList,
		pager: Pager,
		calendar: CalendarPage,
		filterStateIds: UiStates,
		pqmFilter: UiPqmFilter,
	}>;

	// @ts-ignore
	ui: MuUi<{
		cGroupedByItem: HTMLInputElement,

	}>;

    public async loadTicket(id: number, metadata: any): Promise<any> {
		this.muClear('ticketDetail');
		if (!metadata || !metadata.projectCode) metadata = await this.ticketsCL.getTicketMetadata(id);
		this.router!.pushUpdate('ticket', { ticketId: this.createTicketRid(metadata) });
		let widget: PqmTicketDetail|TodoTicketForm;

		switch (metadata.projectCode) {
			case 'PQM':
				widget = this.openInDetail<PqmTicketDetail>(
					"PqmTicketDetail"
				);
				// @ts-ignore
				this.currentTicket = (await widget.doLoad(id)).ticket;
				break;
			case 'TODO':
				widget = this.openInDetail<TodoTicketForm>(
					"TodoTicketForm",
					{ addTitle: true }
				);
				// @ts-ignore
				this.currentTicket = await widget.doLoad(id, "ticket");
				break;
		}
		this.markSelectedTicket();
		widget!.addEventListener('saved', item => this.loadList(false));

		return null;
    }

	openInDetail<T>(name: string, params: any = {}): T
	{
		this.muClear('ticketDetail');
		return this.createWidgetIn<T>(
			name,
			"ticketDetail",
			params
		);
	}

	getLastPqmItemId() {
		return this.filter.masterPqmItemId;
	}

	pqmFilter_change(ev:any, pqmItemId: number, items: any[]) {
		this.filter.masterPqmItemId = pqmItemId;
		if (this.isGgroupedByPI) {
			this.muBindData({ pqmItems: items });
		} else this.loadList();
	}

	protected get isGgroupedByPI(): boolean {
		return ((this.currentSubProfile.layout || "list") === 'list')
			&& this.currentSubProfile.groupByPqm
			&& this.ui.cGroupedByItem.checked;
	}

	public async getTicketsByFilter(ui: any, limitFrom: number, limitCount: number, filter: any = {})
	{
		return await this.ticketsCL.withMessage("Načítám položky", ui).getTickets(
			this.profile.id,
			this.currentSubProfile.id,
			{
				fulltext: this.ui.cFulltext.value,
				stateId: this.muNamedWidget.filterStateIds.muFetchData(),
				...this.filter,
				...filter,
			},
			limitFrom,
			limitCount
		);
	}

	protected scProfiles = {
		true: [
			[ 5, 7, 6, 6 ],
			[ 3, 9, 0, 12 ],
			[ 0, 12, 0, 0 ],
		],
		false: [
			[ 3, 9, 0, 12 ],
			[ 0, 12, 0, 0 ],
		]
	}

    protected async loadList(loadNext: boolean = true): Promise<any> {
		this.router?.update(null, { filter: JSON.stringify(this.filter) });
		this.setupPaneSizes(0);
		const layout = this.currentSubProfile.layout || "list";
		for(const l of [ "calendar", "list" ]) {
			this.muVisible(l === layout, l);
		}

		if (layout === "calendar") {
			await this.muNamedWidget.calendar.init();
		} else {
			this.muVisible(!!this.currentSubProfile.groupByPqm, 'lGroupedByItem');
			if (this.isGgroupedByPI) {
				const data = await this.ticketsCL.withMessage("Načítám položky", this.ui.sidePanel).getPqmTicketStats(
					this.profile.id,
					this.currentSubProfile.id,
					{
						fulltext: this.ui.cFulltext.value,
						stateId: this.muNamedWidget.filterStateIds.muFetchData(),
						...this.filter
					}
				);
				this.muClear('overviewItems');
				this.ui.overviewPqmItems.innerText = "Vyberte proces vpravo";
				this.muNamedWidget.pqmFilter.bindData(data);
				this.muVisible(false, 'pager');
			} else {
				const data = await this.getTicketsByFilter(
					this.ui.sidePanel,
					this.muNamedWidget.pager.currentItemFrom ?? 0,
					this.muNamedWidget.pager.itemPerPage
				);
				this.muClear('overviewPqmItems');
				this.muBindData(data);
				this.muNamedWidget.pager.setItemCount(data.fullCount);
				(this.muNamedWidget.pager as unknown as Pager).setItemCount(data.fullCount);
				if (data.stats && data.stats[0].name) this.muNamedWidget.pqmFilter.bindData(data.stats);
				this.muVisible(true, 'pager');
			}
		}

		return Promise.resolve();
    }

	pager_changePage() {
		this.loadList(false);
	}

	beforeIndex() {
		this.muAppendContent(
			this.htmlNavSubprofiles(true)
			+ this.htmlToolbar(false, true, false)
			+ `
			<div mu="calendar:CalendarPage" style="display: none"></div>
			<div class="row" mu="list" style="display: none">
				<div mu="sidePanel" class="col-sm-${this.ticketListSize} display-flex-column gap-3">
					<div mu="stateGroups">
						<span mu=":.@stateGroup" class="btn"></span>
					</div>
					<div mu="filterStateIds:UiStates"></div>
					<div class="row">
						<div mu="pqmFilter:UiPqmFilter" class="ticket-overview__pqm-filter-process"></div>
						<div mu="overviewContainer" class="ticket-overview__pqm-filter-step">
							<label mu="lGroupedByItem"><input type="checkbox" mu="cGroupedByItem" checked="checked"> Seskupit dle činnosti</label>
							<div mu-id="overviewItems" mu-bind="items:@foreach" class="layout-pqm-default">
								<div mu=":TOIPqm@overviewItem"></div>
							</div>
							<div mu-id="overviewPqmItems" mu-bind="pqmItems:@foreach" class="layout-pqm-default">
								<div mu=":PqmSteps@pqmStep"></div>
							</div>
						</div>
					</div>
					<div mu-widget="Pager" mu-id="pager"></div>
				</div>
				<div mu="ticketDetail" class="col-sm-${12 - this.ticketListSize}">
				</div>
			</div>
		`);
		this.container.classList.add("ticket-overview");
		this.setupRouter();
		this.overviewLayoutPrefix = "pqm-";
	}

	protected setupRouter() {
		this.router = new BaseRouter();
		this.router.pathPrefix = "/ticket/overview/" + this.profile.code;

		this.router.persistentKeys = [ "subprofile" ];

		this.router!.paTicket = (oa, ticket) => {
			Arrays.ooaToArray(oa).forEach(
				a => this.router!.prepareAnchor(a, "ticket", { ticketId: this.createTicketRid(ticket) }, true)
			);
		};
		const findSubProfile = async(id: string) => (await this.subprofiles.fetch()).find((sp: SubProfile) => sp.id === id);
		const reactivateProfile = async(rc: MuRouterContext) => {
			if (rc.parameters.subprofile !== this.currentSubProfile?.id)
				this.activateSubProfile(await findSubProfile(rc.parameters.subprofile as string), false);
		};
		this.router!.addRoute('createPqmTicket', '/<subprofile>/createPqmTicket/<pqmItemId>',
			async(rc) => {
				const md: any = {};
				// @ts-ignore
				this.doNewPqmTicket(parseInt(rc.parameters.pqmItemId));
				await reactivateProfile(rc);
			});
		this.router!.addRoute('ticket', '/<subprofile>/<ticketId>',
			async(rc) => {
				const md: any = {};
				[ md.id, md.projectCode, md.ticketTypeCode ] = rc.parameters.ticketId!.split('-');
				this.loadTicket(parseInt(md.id), md);
				if (rc.parameters.subprofile === "calendar") rc.parameters.subprofile = "all";
				await reactivateProfile(rc);
			});

		this.router.addRoute('overview', '/<subprofile>',
			async(rc) =>
				this.activateSubProfile(await findSubProfile(rc.parameters.subprofile as string), true)
		);

		this.router.addRoute('root', '',
			async (rc) => this.activateSubProfile((await this.subprofiles.fetch())[0], true));

	}

	async afterIndex() {
		super.afterIndex();
		this.setupSubProfiles(await this.subprofiles.fetch());
		this.router!.route();
	}

	cGroupedByItem_change() {
		this.loadList();
	}

	private createTicketRid(ticket: Ticket): string {
		return ticket.id.toString() + "-" + ticket.projectCode + "-" + ticket.ticketTypeCode;
	}

	async bAdd_click() {
		if (this.currentSubProfile.id === "calendar") {
			this.muNamedWidget.calendar.calendar_add(null, null);
		} else if (this.currentSubProfile.id === "todo") {
			const widget = this.openInDetail<TodoTicketForm>(
				"TodoTicketForm",
				{ addTitle: true }
			);
			widget.doNew();
			if (await widget.eventPromise('saved', null)) await this.loadList();
		} else {
			let ws = this.openInDetail<UiPqmLauncher>("UiPqmLauncher"/*, "Vyberte proces ke spuštění" */);
			const val = await ws.eventPromise('start', null);
			ws.muRemoveSelf();

			if (val) {
				this.router?.pushUpdate('createPqmTicket', { pqmItemId : val, ticketId: null });
				this.doNewPqmTicket(val);
			}
		}
	}

	async doNewPqmTicket(pqmItemId: number) {
		const we = this.openInDetail<PqmTicketDetail>('PqmTicketDetail');
		await we.doNew(pqmItemId);
		if (await we.eventPromise('saved', false) !== null) this.loadList(false);
	}

	filterStateIds_change() {
		this.dslLoadList.send();
	}

	activateSubProfile(subProfile: SubProfile, loadFirst: boolean) {
		// @ts-ignore
		const items = subProfile.states.map(s => ({ id: s.id.toString(), title: s }));
		this.muNamedWidget.filterStateIds.bindItems(items);
		this.muNamedWidget.filterStateIds.checkBy(
			item => !subProfile.defaultStates || subProfile.defaultStates.includes(item.title.code)
		);
		super.activateSubProfile(subProfile, loadFirst);
		this.muVisible(subProfile.layout !== 'calendar', 'toolbar');

		const stateCode2Id = Object.fromEntries(subProfile.states.map(state => [ state.code, state.id.toString() ]));
		// Skupiny stavů
		this.muClear('stateGroups');
		if (subProfile.stateGroups) {

			for(const stateGroup of subProfile.stateGroups || []) {
				const stateIds = stateGroup.states.map(c => stateCode2Id[c]);
				this.muWidgetFromTemplate('stateGroup', 'stateGroups', {
					afterIndex: function () {
						const c = ((this as MuWidget).container as unknown as HTMLElement);
						const color = stateGroup.color || "#ffffff";
						c.innerText = stateGroup.name;
						c.style.color = MuBinder.filters.bwContrasted(color);
						c.style.backgroundColor = color;
					},
					container_click: () => {
						this.muNamedWidget.filterStateIds.muBindData(stateIds);
						this.loadList();
					},
				});
			}
			this.muWidgetFromTemplate('stateGroup', 'stateGroups', {
				afterIndex: function () {
					const c = ((this as MuWidget).container as unknown as HTMLElement);
					c.innerText = "...";
					c.title = "Podrobnější výběr stavů";
				},
				container_click: () => this.muVisible("toggle", "filterStateIds"),
			});
		}
		this.muVisible(!subProfile.stateGroups, "filterStateIds");

		const groupByPqm = subProfile.groupByPqm === "master";

		// this.ui.pqmFilter.classList.toggle('col-sm-6', groupByPqm);
		// this.ui.overviewContainer.classList.toggle('col-sm-6', groupByPqm);

		// this.muVisible(groupByPqm, "pqmFilter");

		this.filter.masterPqmItemId = null;

		this.setupPaneSizes(0);
	}

	protected setupPaneSizes(index: number|"next") {
		const groupByPqm = this.currentSubProfile.groupByPqm === "master";

		if (index === 'next') this.panelSizesIndex++;
		else this.panelSizesIndex = index;

		// @ts-ignore
		if (this.panelSizesIndex >= this.scProfiles[groupByPqm].length) this.panelSizesIndex = 0;

		const sizes: Record<string, number|undefined> = {};
		// @ts-ignore
		[ sizes.sidePanel, sizes.ticketDetail, sizes.pqmFilter, sizes.overviewContainer ] = this.scProfiles[groupByPqm][this.panelSizesIndex];
		for(const id in sizes) {
			if (sizes[id] !== undefined) {
				const s = sizes[id];
				this.muVisible(s !== 0, id);
				changeClassStartsWith(this.ui[id].classList, 'col-sm-', s!.toString());
			}
		}
	}

	bSwitchLayout_click() {
		this.setupPaneSizes("next");
	}

	protected panelSizesIndex: number = 0;

	protected dslLoadList = new DelayedSingleLauncher(2, () => this.loadList(false));

}

export class UiStates extends UiChboxList {
	beforeIndex() {
		this.muAppendContent(`<label mu-bind="color:style.backgroundColor;color|bwContrasted:style.color" 
				mu-template="item" mu-widget="UiChboxListItem" class="badge">
			<input type="checkbox" mu-id="input">
			<span mu="title#name"></span>
		</label>`);
		super.beforeIndex();
	}
}

export class PqmSteps extends BaseMuWidget
{
	// @ts-ignore
	public name: string;
	// @ts-ignore
	public pqmItemId: number;
	// @ts-ignore
	public count: number;

	public loadedTicketCount: number = 0;

	public pageSize: number = 50;

	public fullCount: number = -1;

	beforeIndex() {
		this.muAppendContent(`
			<label class="cursor-pointer checkbox-collapse d-block" mu="header">
				<input type="checkbox" mu="collapsed" />
				<span></span>
				<strong mu="#name" class="flex-grow-1"></strong>
				<span class="badge bg-secondary float-right" mu="#count"></span>			
			</label>
			<div mu="content">
				<div mu="list">
					<div mu=":.@overviewItem" class="cursor-pointer"><a mu="link">
						<em mu="#evidenceUid"></em><span mu="#summary"></span>
					</a></div>
				</div>
				<div class="buttons" mu="buttons">
					<span class="btn btn-link" mu="bLoadNexts">Načíst další</span>
				</div>
			</div>
		`);
	}

	collapsed_change() {
		this.muVisible(this.ui.collapsed.checked, "content");
		if (this.loadedTicketCount === 0 && this.ui.collapsed.checked) {
			// Automaticky načti první várku při otevření
			this.loadNextTickets();
		}
	}

	afterIndex() {
		this.collapsed_change();
		// this.ui.name.innerText = this.name;
		// this.ui.count.innerText = this.count.toString();
	}

	protected muAfterBindData(data: any) {
		this.pqmItemId = data.pqmItemId;
		this.name = data.name;
	}

	async loadNextTickets() {
		this.muVisible(false, 'bLoadNexts');
		const data = await this.callMethodInFirstAncestors(
			'getTicketsByFilter',
			this.ui.buttons,
			this.loadedTicketCount,
			this.pageSize,
			{
				pqmItemId: this.pqmItemId,
			}
		);
		this.loadedTicketCount += data.items.length;
		this.fullCount = data.fullCount;
		this.muVisible(this.loadedTicketCount < this.fullCount, 'bLoadNexts');
		this.muBindList(
			data.items,
			'overviewItem',
			'list',
			{ },
			(widget, item) => {
				this.getRouter().paTicket([widget.container, widget.ui.link], item);
				widget.muBindData({ ...item, summary: item.summary.replace(this.name, ' ') || item.summary });
			}
		);
		console.log(data);
	}

	bLoadNexts_click() {
		this.loadNextTickets();
	}
}
